import { Popper } from '@material-ui/core';
import styled from 'styled-components';
import { colorUsage } from 'stylesheet';
var anchorSize = 24; // in px

var anchorAreaMargin = 6; // in px

var AnchorDiv = styled.div.withConfig({
  displayName: "ImageAnchorSelectorstyle__AnchorDiv",
  componentId: "sc-15vcos5-0"
})(["position:absolute;top:", ";left:", ";width:", "px;height:", "px;cursor:pointer;"], function (_ref) {
  var anchor = _ref.anchor;
  return "calc(".concat(anchor.positionY, "px - ").concat(anchorSize / 2, "px - ").concat(anchorAreaMargin, "px) ");
}, function (_ref2) {
  var anchor = _ref2.anchor;
  return "calc(".concat(anchor.positionX, "px - ").concat(anchorSize / 2, "px - ").concat(anchorAreaMargin, "px) ");
}, anchorSize, anchorSize);
var AnchorContainer = styled.div.withConfig({
  displayName: "ImageAnchorSelectorstyle__AnchorContainer",
  componentId: "sc-15vcos5-1"
})(["position:relative;width:100%;height:100%;"]);
var CustomPopper = styled(Popper).withConfig({
  displayName: "ImageAnchorSelectorstyle__CustomPopper",
  componentId: "sc-15vcos5-2"
})([".tooltip{color:", ";background-color:", ";}"], colorUsage.anchor.textColor, colorUsage.anchor.backgroundTextColor);
export { AnchorContainer, AnchorDiv, CustomPopper };